module.exports = __webpack_public_path__ + "static/media/comsense_logo.8225e42f.png";